// extracted by mini-css-extract-plugin
export default {"circle":"FloatingShapes_circle__Ut1OF","floatCircle":"FloatingShapes_floatCircle__AsDS9","rect":"FloatingShapes_rect__mEWE2","floatRect":"FloatingShapes_floatRect__Mw6EM"};